import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var SeoTextReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default SeoTextReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/SeoText/SeoTextReduxProps.ts
// module id = 464
// module chunks = 0